
import router from './router'
//调用接口
import url from "./common/api";
import { tokenLogin } from "./common/operateToken";
// 路由发生变化修改页面title/meta
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面meta */
    // console.log(to,from,'-------路由微信登录----------------')
    if(to.path=='/jump'){
      //微信登录跳转
      // console.log(to.query,'--------微信登录跳转')
      if(to.query.state=='zhuangtai'){
        url.qrcode({
          code:to.query.code
        }).then(res=>{
          if(res.data.code[0]=="200"){
            Fngetresult(res)
            // console.log(res,'---------------')
            // ----------------------------
            let resultD=res.data.data[0].fields
            if(resultD.is_engineer && resultD.u_type == '未审核工程师'){//是不是工程师
              next('/UserInformation/auditInfo')
            }else if(resultD.is_engineer && resultD.u_type == '工程师'){
                next('/engineerIndex')
            }else{
                if(resultD.is_staff){//是否有公司或是员工
                  next('/index/MFprojectManagement')
                }else{
                  next('/UserInformation/UItwo')
                }
            }
            // ----------------------------
          }else{
            // this.$message.error(res.data.message[0]);
            next('/homeIndex?tip=用户不存在，请使用密码登录')//个人信息
          }
        })
      }else{
        // 绑定
        url.qrcodev1({
          code:to.query.code,
          user_id:to.query.state
        }).then(res=>{
          if(res.data.code[0]=="200"){
            Fngetresult(res)
            next('/UserInformation/UItwo')//个人信息
            // ----------------------------
          }else if(res.data.code[0]=="921"){
            Fngetresult(res)
            next('/UserInformation/UItwo?tip=不可重复绑定')//个人信息
          }else{
            // this.$message.error(res.data.message[0]);
            next('/homeIndex?tip=发生错误请重新登录')//个人信息
          }
        })
      }
  
      
    }else{
      if(to.meta.content){
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        meta.content = to.meta.content;
        head[0].appendChild(meta)
       }
       /* 路由发生变化修改页面title */
       if (to.meta.title) {
        document.title = to.meta.title;
       }
       next()
    }
  });
function Fngetresult(res) {
  let LToken={
    token:res.data.access,
    resetTime:res.data.access_time,
    refresh_token:res.data.refresh,
  }
  tokenLogin(LToken)
  let xx=res.data.data[0].fields
  xx.user_id=res.data.data[0].pk
  sessionStorage.setItem('weixinUser',JSON.stringify(xx));
  sessionStorage.setItem('weixinsetcompanyname',res.data.companyname);
  if(xx.is_engineer && xx.u_type == '未审核工程师'){//是不是工程师
    sessionStorage.setItem('logi', '未审核工程师');
  }else if(xx.is_engineer && xx.u_type == '工程师'){
    sessionStorage.setItem('logi', '工程师');
  }else{
    if(xx.is_staff){//是否有公司或是员工
      sessionStorage.setItem('logi', '设备管理');
    }else{
      sessionStorage.setItem('logi', '个人信息');
    }
  }
}
  
  


// WEBPACK FOOTER //
// ./src/GlobalRouteInterception.js